import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";
import { DealLayoutHeaderClient } from "~/components/common/layouts/deals/DealLayoutHeaderClient";
import type { Deal } from "~/models/Deal";
import { showNewFeatureForLocal } from "~/utils/FeatureFlagUtil";
import Styles from "./DealLayout.module.scss";

type Props = {
	children: ReactNode;
	deal: Deal;
	enableChat?: boolean;
	items: ComponentProps<typeof DealLayoutHeaderClient>["items"];
	noBackground?: boolean;
	useSimpleSpHeader?: boolean;
};

export function ClientDealLayout({
	deal,
	children,
	items,
	noBackground = false,
	useSimpleSpHeader = false,
	enableChat = false
}: Props) {
	return (
		<div>
			<DealLayoutHeaderClient
				deal={deal}
				enableChat={enableChat ? showNewFeatureForLocal() : false}
				// https://itandi-dev.atlassian.net/browse/NSKDEV-2956で追加
				isChatOpen
				items={items}
				// https://itandi-dev.atlassian.net/browse/NSKDEV-2956で追加
				onToggleChat={() => {}}
				useSimpleSpHeader={useSimpleSpHeader}
			/>
			<div
				className={clsx(
					Styles.Container,
					noBackground ? Styles.Transparent : Styles.White
				)}
			>
				{children}
			</div>
		</div>
	);
}
